import script from "./burger_menu.vue?vue&type=script&setup=true&lang=js"
export * from "./burger_menu.vue?vue&type=script&setup=true&lang=js"

import "./burger_menu.vue?vue&type=style&index=0&id=a4e2325a&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4e2325a"]])

export default __exports__